<template>
  <form class="component-students-modal" @submit.prevent="submit">
    <div class="d-flex align-items-center justify-content-between pb-3">
      <span class="fs-18">
        {{ label }}
      </span>
      <button class="btn btn-sm btn-square" @click.prevent="$emit('close')">
        <i class="icon-x fs-20 text-secondary" />
      </button>
    </div>
    <div class="row">
      <div class="col-12">
        <form-group
          v-model="form.name"
          :errors="errors.name"
          :disabled="!!student.id"
          id="name"
          placeholder="Ex: John Doe"
          label="Nome do aluno"
          required
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="form.email"
          :errors="errors.email"
          :disabled="!!student.id"
          type="email"
          id="email"
          placeholder="Ex: john@email.com"
          label="E-mail"
          required
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="form.phone"
          :errors="errors.phone"
          type="tel"
          id="phone"
          placeholder="(00) 00000-0000"
          :mask="phoneMask"
          label="Telefone"
          required
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="form.expires_in"
          :errors="errors.expires_in"
          type="tel"
          id="expires_in"
          is-date
          mode="date"
          :minDate="new Date()"
          placeholder="Selecione a data..."
          label="Data de expiração"
        />
      </div>
      <div class="col-lg-6">
        <action-dispatcher
          small
          action="membersGroups/getAll"
          :parameters="{
            product_id: $route.params.id,
            limit: 1000
          }"
        >
          <form-group
            v-model="form.group_id"
            :errors="errors.group_id"
            id="group_id"
            placeholder="Selecione"
            label="Turma"
            select
            :options="groups"
            nullable
          />
        </action-dispatcher>
      </div>
      <div class="col-12 mt-5 d-lg-none">
        <button class="btn btn-primary btn-40 btn-block" @click="submit">
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
      <div class="col-12 mt-5 d-lg-none">
        <button
          class="btn btn-secondary btn-40 btn-block"
          @click="$emit('close')"
        >
          Cancelar
        </button>
      </div>
    </div>
    <div class="d-none d-lg-flex justify-content-end align-items-center mt-5">
      <button
        class="btn btn-secondary btn-40"
        @click="$emit('close')"
        type="button"
      >
        Cancelar
      </button>
      <button class="btn btn-primary btn-40 ml-5" type="submit">
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>
  </form>
</template>
<script>
import { formFields, toComputerDate, toHumanDate } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    student: {
      type: Object,
      default: () => {}
    },
    studentErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(
        ["name", "email", "phone", "expires_in", "group_id", "product_id"],
        {
          ...this.student,
          product_id: this.$route.params.id,
          group_id: get(this.student, "group_id"),
          expires_in: toHumanDate(get(this.student, "expires_in", ""))
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersGroups", ["groups"]),
    label() {
      return this.student.id ? "Editar aluno" : "Adicionar aluno";
    },
    phoneMask() {
      if (this.form?.phone?.length < 11) return "## ####-#####";
      if (this.form?.phone?.length == 11) return "## #####-#####";
      if (this.form?.phone?.length == 12) return "## ######-#####";
      return "## ## #####-####";
    }
  },
  methods: {
    submit() {
      this.loading = true;

      const data = { ...this.form };
      data.expires_in = data.expires_in
        ? toComputerDate(data.expires_in)
        : null;

      data.phone = data.phone?.replace(/[\s-]/g, "") || null;
      let action = "membersStudents/post";

      if (this.student?.id) {
        data.id = this.student.id;
        action = "membersStudents/put";
      }

      if (!data.group_id) {
        if (this.student.id) data.group_id = null;
        else delete data.group_id;
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.$emit("success");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.message) {
            this.$message.error(this.errors.message);
          }
        })
        .finally(() => (this.loading = false));
    }
  },
  mounted() {
    this.errors = { ...this.errors, ...this.studentErrors };
  }
};
</script>
